<template>
  <div>
    <h1 class="title is-4 mb-4 mt-6">{{ title }}</h1>
    <div class="columns is-desktop">
      <!-- Selected Makes -->
      <div class="column">
        <ChartCard
          :title="primaryTitle"
          :chart-data="primaryChartData"
          :colors="colors"
          :total-label="totalLabel"
        />
      </div>

      <!-- Competitors -->
      <div class="column">
        <ChartCard
          :title="competitorTitle"
          :chart-data="competitorChartData"
          :colors="colors"
          :total-label="totalLabel"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChartSection',
  props: {
    title: String,
    primaryData: Object,
    competitorData: Object,
    colors: Array,
    totalLabel: String
  },
  computed: {
    ...mapGetters('stockcompare/dashboard', ['myMakes', 'competitorMakes']),

    primaryTitle() {
      if (!this.myMakes || this.myMakes.length === 0) {
        return 'You'
      }

      const makeNames = this.myMakes.map(make => {
        return make.name || make.make || make
      })

      return makeNames.join(' & ')
    },

    competitorTitle() {
      if (!this.competitorMakes || this.competitorMakes.length === 0) {
        return 'Competitors'
      }

      const makeNames = this.competitorMakes.map(make => {
        return make.name || make.make || make
      })

      return makeNames.join(' & ')
    },

    primaryChartData() {
      return this.primaryData
    },

    competitorChartData() {
      return this.competitorData
    }
  },

  components: {
    ChartCard: () => import('./StockCompareChartCard')
  }
}
</script>
